import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import TableTop from "../../../Components/UI/TableTop";
import {
  useCPFContributionQuery,
  useInsertCPFContributionMutation,
  useUpdateCPFContributionMutation,
} from "../../../AppQuries/master/CpfContribution/contributions";
import Loader from "../../../feature-module/loader/loader";
import { useTableSearch } from "../../../core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import Breadcrumbs from "core/breadcrumbs";
import CpfContributionModal from "Components/Modal/master/CpfContributionModal";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import { useGetCPFPercentageFliQuery } from "AppQuries/master/CpfPercenatgeFli/cpf-percentage-fli";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const CPFPercentageFLI = () => {
  const userData = useSelector(loggedInUser);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetCPFPercentageFliQuery();
  const methods = useForm();
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem } = useInsertCPFContributionMutation();
  const { mutate: updateItem } = useUpdateCPFContributionMutation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  console.log(data);
  const ItemData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      contributionCode: 0,
      contributionName: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      contributionCode: item.contributionCode,
      contributionName: item.contributionName,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          if (data) {
            setMessage("Updated Successfully.");
            setShowSuccessToast(true);
            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            setMessage("Something went wrong.");
            setShowErrorToast(true);
          }
        },
        onError: (error) => {
          setMessage(error.message || "Something went wrong.");
          setShowErrorToast(true);
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          if (data) {
            setMessage("Created Successfully.");
            setShowSuccessToast(true);
            setShow(false);
            GetItems();
          } else {
            setMessage(error.message || "Something went wrong.");
            setShowErrorToast(true);
          }
        },
        onError: (error) => {
          setMessage(error.message || "Something went wrong.");
          setShowErrorToast(true);
        },
      });
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text}</>,
    },
    {
      title: "CPF Type",
      dataIndex: "cpftype",
      fixed: "left",
      sorter: (a, b) => a.cpftype.length - b.cpftype.length,
    },

    {
      title: "Age From",
      dataIndex: "ageFrom",
      sorter: (a, b) => a.ageFrom.length - b.ageFrom.length,
    },
    {
      title: "Age To",
      dataIndex: "ageTo",
      sorter: (a, b) => a.ageTo.length - b.ageTo.length,
    },
    {
      title: "Salary From",
      dataIndex: "salaryFrom",
      sorter: (a, b) => a.salaryFrom.length - b.salaryFrom.length,
    },
    {
      title: "Salary To",
      dataIndex: "salaryTo",
      sorter: (a, b) => a.salaryTo.length - b.salaryTo.length,
    },
    {
      title: "Employee Percentage",
      dataIndex: "employeePercentage",
      sorter: (a, b) =>
        a.employeePercentage.length - b.employeePercentage.length,
    },
    {
      title: "Employer Percentage",
      dataIndex: "employerPercentage",
      sorter: (a, b) =>
        a.employerPercentage.length - b.employerPercentage.length,
    },
    {
      title: "Employee Percentage Salary Ceiling",
      dataIndex: "employeePercentageSalaryCeiling",
      sorter: (a, b) =>
        a.employeePercentageSalaryCeiling.length -
        b.employeePercentageSalaryCeiling.length,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_cpfpercentagefli}
            accessType="haveEdit"
          >
            <Link
              className="me-2 p-2"
              to={`${all_routes.master}${all_routes.edit_cpfPercentageFLI}/${record.code}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </Can>
        </div>
      ),
    },
  ];
  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>CPF Percentage FLI List</h4>
              <h6>Manage Compnay Percentage FLI</h6>
              {/* <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-arrow mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="fas fa-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="..">Master</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CPF Contributions
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_cpfpercentagefli}
                accessType="haveAdd"
              >
                <Link
                  to={`${all_routes.master}${all_routes.add_cpfPercentageFLI}`}
                  className="btn btn-added"
                  onClick={handleAddClick}
                >
                  <PlusCircle className="me-2" />
                  Add CPF Percentage FLI
                </Link>
              </Can>
              &nbsp;
              <Link
                to={`${all_routes.master}${all_routes.add_multi_cpfPercentageFLI}`}
                className="btn btn-added"
                onClick={handleAddClick}
              >
                <PlusCircle className="me-2" />
                Add CPF Percentage (Multiple)
              </Link>
              &nbsp;
              <Link to={`${all_routes.master}`} className="btn btn-secondary">
                <i className="fas fa-reply me-2"></i>
                Back
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CPFPercentageFLI;
